export const UserRoles = Object.freeze({
  ADMIN: 'admin',
  EMPLOYEE: 'employee',
  USER: 'user',
});

export default {
  UserRoles,
};
